import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCompanyManagedAgentsRoute: InvariantJiraRoute = {
	name: 'software-company-managed-agents',
	path: '/jira/software/c/projects/:projectKey/settings/agents',
	exact: true,
};
